<template>
  <div class="bookMeetings">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('我的会议')" />
    <div class="selectionBar">
      <van-search v-model="searchValue" :placeholder="$t('搜索')" @search="onSearch" class="search-box" />
      <div class="calendar" @click="dateShow = true">
        <img src="@/assets/images/calendar.png" alt="" />
      </div>
    </div>
    <van-tabs v-model="active" color="#009BFF" @click="onTabClick">
      <van-tab :title="$t('未结束')">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
          :style="{ height: height - 20 + 'px', overflow: 'auto' }">
          <van-list v-model="myLoading" :finished="myFinished" @load="onLoad" :immediate-check="false">
            <div class="loading-style" v-if="isLoading">
              <!-- <van-loading type="spinner" vertical>{{
                $t('加载中...')
              }}</van-loading> -->
            </div>
            <div class="content" v-else>
              <ul v-if="reserveList.length > 0">
                <li class="card" v-for="item in reserveList" :key="item.id">
                  <div @click="mettingInfo(item, 0)">
                    <div class="card-header">
                      <div class="area">{{ item.appointmentTopic }}</div>
                      <div class="meetingStatus" v-if="item.stateName">
                        <div class="meetingStatusColor">
                          {{ item.stateName }}
                        </div>
                      </div>
                      <!-- <img
                        src="@/assets/images/squareB.png"
                        alt=""
                        @click.stop="mettingInfo(item, 1)"
                      /> -->
                    </div>
                    <div class="time-header">
                      <div class="meetingtime">
                        {{ $t('时间：')
                        }}{{
                          dayjs(
                            item.appointmentStartTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('YYYY/MM/DD')
                        }}
                        {{
                          dayjs(
                            item.appointmentStartTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('HH:mm')
                        }}-{{
                          dayjs(
                            item.appointmentEndTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('HH:mm')
                        }}
                      </div>
                      <img src="@/assets/images/today.png" alt="" class="today-icon" v-if="
                        dayjs().format('YYYY-MM-DD') ===
                        dayjs(
                          item.appointmentStartTime,
                          'YYYY-MM-DD HH:mm:ss'
                        ).format('YYYY-MM-DD')
                      " />
                    </div>
                    <div class="time-header">
                      <div class="meetingtime">
                        {{ $t('地点：')
                        }}{{
                          (item.meetingRoomDto && item.meetingRoomDto.name) ||
                          $t('线上会议')
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="operation" v-if="item.appointmentStaff == user.id">
                    <div @click="onEarlyEnd(item)" class="cancelDestine" v-if="item.earlyEnd">
                      {{ $t('提前结束') }}
                    </div>
                    <div @click="onCancel(item)" class="cancelDestine" v-if="!item.earlyEnd">
                      {{ $t('取消') }}
                    </div>
                    <div @click.stop="mettingInfo(item, 1)" class="editDestine"
                      v-if="!item.isIrrevocable && !item.processMeetingId">
                      {{ $t('编辑') }}
                    </div>
                  </div>
                  <div class="operation" v-if="
                    item.appointmentStaff != user.id &&
                    item.stateName != $t('已确认')
                  ">
                    <div @click="onRefuse(item, 0)" class="rejectDestine" v-if="item.stateName == $t('待确认')">
                      {{ $t('拒绝') }}
                    </div>
                    <div @click.stop="checkRepeat(item)" class="editDestine">
                      {{ $t('同意') }}
                    </div>
                  </div>
                </li>
              </ul>
              <div class="no-uesdMeetingRoom" v-if="!overList.length > 0 && !reserveList.length > 0">
                <img src="@/assets/images/empty.png" alt="" />
                <div>{{ $t('暂无信息') }}</div>
              </div>
            </div>
            <div class="bottom" v-show="showMyBottom">
              <div></div>
              <span>{{
                mySearch.length > 0 ? $t('到底啦') : $t('仅显示一周内的会议哦')
                }}</span>
              <div></div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="$t('已结束')">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
          :style="{ height: height - 20 + 'px', overflow: 'auto' }">
          <van-list v-model="inviteLoading" :finished="inviteFinished" @load="onLoad" :immediate-check="false">
            <div class="loading-style" v-if="isLoading">
              <!-- <van-loading type="spinner" vertical>{{
                $t('加载中...')
              }}</van-loading> -->
            </div>
            <div class="content" v-else>
              <ul v-if="appointmentInvitationList.length > 0">
                <li class="card" v-for="item in appointmentInvitationList" :key="item.id">
                  <div @click="mettingInfo(item, 0)">
                    <div class="card-header">
                      <div class="areaMore">{{ item.appointmentTopic }}</div>
                      <div class="meetingStatus" v-if="item.stateName">
                        <div class="meetingStatusColor">
                          {{ item.stateName }}
                        </div>
                      </div>
                    </div>
                    <div class="time-header">
                      <div class="meetingtime">
                        {{ $t('时间：')
                        }}{{
                          dayjs(
                            item.appointmentStartTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('YYYY/MM/DD')
                        }}
                        {{
                          dayjs(
                            item.appointmentStartTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('HH:mm')
                        }}-{{
                          dayjs(
                            item.appointmentEndTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('HH:mm')
                        }}
                      </div>
                      <img src="@/assets/images/today.png" alt="" class="today-icon" v-if="
                        dayjs().format('YYYY-MM-DD') ===
                        dayjs(
                          item.appointmentStartTime,
                          'YYYY-MM-DD HH:mm:ss'
                        ).format('YYYY-MM-DD')
                      " />
                    </div>
                    <div class="time-header">
                      <div class="meetingtime">
                        {{ $t('地点：')
                        }}{{
                          (item.meetingRoomDto && item.meetingRoomDto.name) ||
                          $t('线上会议')
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="operation" v-if="item.appointmentStaff == user.id && !item.processMeetingId">
                    <div @click="mettingInfo(item, 2)" class="orderDestine">
                      {{ $t('再次预定') }}
                    </div>
                  </div>
                </li>
              </ul>
              <div class="no-uesdMeetingRoom" v-else>
                <img src="@/assets/images/empty.png" alt="" />
                <div>{{ $t('暂无信息') }}</div>
              </div>
            </div>
            <div class="bottom" v-show="showInviteBottom">
              <div></div>
              <span>{{
                inSearch.length > 0 ? $t('到底啦') : $t('仅显示一周内的会议哦')
                }}</span>
              <div></div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <van-popup v-model="dateShow" position="bottom" :style="{ height: '630px' }">
      <div class="dateModalTab">
        <div class="dateModalList">
          <div v-for="item in allTime" :key="item.key" :style="{
            backgroundColor: item.backgroundColor,
            color: item.color,
          }" class="dateModalListOne" @click="choseTime(item)">
            <div class="dateModalListText">
              {{ item.value }}
            </div>
          </div>
        </div>
        <div class="dateModalList" v-if="active == 0">
          <div v-for="item in allStates" :key="item.key" :style="{
            backgroundColor: item.backgroundColor,
            color: item.color,
          }" @click="choseStatus(item)" class="dateModalListOne">
            <div class="dateModalListText">
              {{ item.value }}
            </div>
          </div>
        </div>
        <div class="dateModalList" v-if="active == 1">
          <div v-for="item in allAction" :key="item.key" :style="{
            backgroundColor: item.backgroundColor,
            color: item.color,
          }" @click="choseAction(item)" class="dateModalListOne">
            <div class="dateModalListText">
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
      <van-calendar @confirm="onConfirm" @select="onSelect" :title="$t('日期选择')" :min-date="minDate" color="#009BFF"
        :formatter="formatter" :poppable="false" :style="{ height: '500px' }" />
    </van-popup>
    <!-- <van-action-sheet
      v-model="areaShow"
      :actions="areaNameList"
      title="选择地区"
      @select="onAreaConfirm"
    /> -->
    <van-dialog v-model="showCancel" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="clickeCancel" class="outsiderStyle" :cancelButtonText="$t('暂不')" :confirmButtonText="$t('确定')">
      <template #title>
        <div class="outsider-title">{{ $t('取消预订') }}</div>
      </template>
      <div class="cancel-box">
        <div class="first-cancel">
          {{ $t('时间：')
          }}{{
            dayjs(
              cancelData.appointmentStartTime,
              'YYYY-MM-DD HH:mm:ss'
            ).format('YYYY/MM/DD')
          }}
          {{
            dayjs(
              cancelData.appointmentStartTime,
              'YYYY-MM-DD HH:mm:ss'
            ).format('HH:mm')
          }}-
          {{
            dayjs(cancelData.appointmentEndTime, 'YYYY-MM-DD HH:mm:ss').format(
              'HH:mm'
            )
          }}
        </div>
        <div>
          {{ $t('地点：')
          }}{{
            (cancelData.meetingRoomDto && cancelData.meetingRoomDto.name) ||
            $t('线上会议')
          }}
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="showEarlyEnd" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="clickeEarlyEnd" class="outsiderStyle" :cancelButtonText="$t('暂不')" :confirmButtonText="$t('确定')">
      <template #title>
        <div class="outsider-title">{{ $t('提前结束') }}</div>
      </template>
      <div class="cancel-box">
        <div class="first-cancel">
          {{ $t('时间：')
          }}{{
            dayjs(
              earlyEndData.appointmentStartTime,
              'YYYY-MM-DD HH:mm:ss'
            ).format('YYYY/MM/DD')
          }}
          {{
            dayjs(
              earlyEndData.appointmentStartTime,
              'YYYY-MM-DD HH:mm:ss'
            ).format('HH:mm')
          }}-
          {{
            dayjs(
              earlyEndData.appointmentEndTime,
              'YYYY-MM-DD HH:mm:ss'
            ).format('HH:mm')
          }}
        </div>
        <div>
          {{ $t('地点：')
          }}{{
            (earlyEndData.meetingRoomDto && earlyEndData.meetingRoomDto.name) ||
            $t('线上会议')
          }}
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="showRefuse" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="ifAgree ? onRefuse(refuseData, 1) : clickeRefuse()" class="outsiderStyle" :cancelButtonText="$t('取消')"
      :confirmButtonText="$t('确认')" :beforeClose="checkRemark">
      <template #title>
        <div class="outsider-title">
          {{ ifAgree ? $t('同意参会') : $t('拒绝参会') }}
        </div>
      </template>
      <!-- <div class="refuse-box">
        <div>{{ifAgree ? '是否确认参加会议？' : '是否拒绝参加会议？'}}</div>
      </div> -->
      <div class="remark-box margin8">
        <van-field v-model="message" rows="2" autosize type="textarea" maxlength="50"
          :placeholder="ifAgree ? $t('请输入留言') : $t('请填写原因说明')" :required="!ifAgree" :error="!ifAgree && !message"
          size="14px" />
      </div>
    </van-dialog>
    <van-dialog v-model="showRepeat" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="onRefuse(refuseData, 1)" class="outsiderStyle" :cancelButtonText="$t('取消')"
      :confirmButtonText="$t('确认')">
      <template #title>
        <div class="repeat-title">{{ $t('同意参会') }}</div>
      </template>
      <div class="repeat-box">
        <div class="repeat-tip">
          {{
            $t(
              '本次会议时间段与您参与的以下会议存在时间重叠，是否确认继续参会？'
            )
          }}
        </div>
        <div :style="{
          paddingBottom: repeatList.length == 1 ? '1.07vw' : '2.13vw',
        }" class="repeat-info">
          <div v-for="item in repeatList" :key="item.appointmentId" class="repeat-info-box">
            <div>{{ item.appointmentTopic }}</div>
            <div>
              {{
                dayjs(item.beginTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
              }}-{{
                dayjs(item.endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="remark-box margin-repaet">
        <van-field v-model="message" rows="2" autosize type="textarea" maxlength="50" :placeholder="$t('请输入留言')"
          size="14px" />
      </div>
    </van-dialog>
    <van-popup v-model="isCancel" position="bottom"
      :style="{ height: '100%', backgroundColor: 'rgba(255, 255, 255, 0)' }">
      <div class="isCancelMask">
        <van-loading type="spinner" vertical>{{ $t('加载中...') }}</van-loading>
      </div>
    </van-popup>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import {
  getWorkspace,
  queryMyAppointmentList,
  // queryInviteMyAppointmentList,
  cancelMeeting,
  deleteAppointment,
  getMeetingRoomConfig,
  refuseMeeting,
  cancelOnlineMeeting,
  dateOverlap,
  saveMeetingMessage,
} from '@/services/api'
import Vue from 'vue'
import dayjs from 'dayjs'
import {
  Calendar,
  Dialog,
  Toast,
  ActionSheet,
  Tab,
  Tabs,
  Search,
  Popup,
  PullRefresh,
  List,
  Loading,
  Field,
} from 'vant'
Vue.use(Calendar)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Popup)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Field)

export default {
  name: 'BookMeetings',
  components: {
    NavBar,
  },
  data() {
    return {
      searchValue: '',
      active: 0,
      newActive: 0,
      allTime: [
        {
          key: 1,
          value: this.$t('全部时间'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
        {
          key: 2,
          value: this.$t('一周内'),
          color: '#ffffff',
          backgroundColor: '#009BFF',
        },
        {
          key: 3,
          value: this.$t('一月内'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
      ],

      allStates: [
        {
          key: 'all',
          value: this.$t('全部状态'),
          color: '#ffffff',
          backgroundColor: '#009BFF',
        },
        // { key: 'appointment', value: '已预订', color: '#666666', backgroundColor: '#F4F4F4' },
        {
          key: 'unconfirmed',
          value: this.$t('待确认'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
        {
          key: 'agree',
          value: this.$t('已确认'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
        {
          key: 'rejected',
          value: this.$t('已拒绝'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
      ],

      allAction: [
        {
          key: 'all',
          value: this.$t('全部状态'),
          color: '#ffffff',
          backgroundColor: '#009BFF',
        },
        {
          key: 'cancel',
          value: this.$t('已取消'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
        {
          key: 'end',
          value: this.$t('已结束'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
      ],

      selectTime: { key: '', value: '' },
      selectStatus: { key: '', value: '' },
      allSearch: '',
      user: {},
      value: 0,
      date: '',
      originDate: '',
      areaShow: false,
      currentArea: '',
      currentAreaId: '',
      areaNameList: [{ name: this.$t('全部') }],
      dateShow: false,
      meetingRoom: [],
      timeRange: [],
      deviceList: [],
      mySearch: [],
      inSearch: [],
      appointmentInvitationList: [],
      overList: [],
      reserveList: [],
      startTime: '',
      endTime: '',
      newStartTime: '',
      newEndTime: '',
      minDate: new Date(2022, 0, 1),
      meetingConfig: null,
      sourceIsH5: true,
      isLoading: false,
      isCancel: false,
      height: '',
      showMyBottom: false,
      myLoading: false,
      myFinished: false,
      myPage: 0,
      invitePage: 0,
      showInviteBottom: false,
      inviteLoading: false,
      inviteFinished: false,
      showCancel: false,
      cancelData: {},
      showEarlyEnd: false,
      earlyEndData: {},
      showRefuse: false,
      refuseData: {},
      showRepeat: false,
      repeatList: [],
      ifAgree: false,
      message: '',
    }
  },
  methods: {
    onTabClick(active) {
      if (active == this.newActive) {
        return
      } else {
        this.myFinished = false
        this.inviteFinished = false
        this.newActive = active
        this.inSearch = []
        this.mySearch = []
        this.overList = []
        this.reserveList = []
        this.appointmentInvitationList = []
        this.originDate = new Date()
        this.myPage = 0
        this.invitePage = 0
        this.searchValue = ''
        this.selectTime = { key: '2', value: this.$t('一周内') }
        this.selectStatus = { key: 'all', value: this.$t('全部状态') }
        this.allTime.map((item, index) => {
          if (index == 1) {
            item.color = '#ffffff'
            item.backgroundColor = '#009BFF'
            this.selectStatus = { key: item.key, value: item.value }
          } else {
            item.color = '#666666'
            item.backgroundColor = '#F4F4F4'
          }
        })
        this.allStates.map((item, index) => {
          if (index == 0) {
            item.color = '#ffffff'
            item.backgroundColor = '#009BFF'
            this.selectStatus = { key: item.key, value: item.value }
          } else {
            item.color = '#666666'
            item.backgroundColor = '#F4F4F4'
          }
        })
        this.allAction.map((item, index) => {
          if (index == 0) {
            item.color = '#ffffff'
            item.backgroundColor = '#009BFF'
            this.selectStatus = { key: item.key, value: item.value }
          } else {
            item.color = '#666666'
            item.backgroundColor = '#F4F4F4'
          }
        })
        this.onLoad()
        // if(this.overList.length == 0 && this.reserveList == 0 && this.active === 0){
        //   this.onLoad()
        // }
      }
    },
    onSearch(val) {
      let params = {}
      if (this.newStartTime) {
        params = {
          endTime: this.newEndTime,
          startTime: this.newStartTime,
          fuzzyValue: val,
        }
      } else {
        params = {
          fuzzyValue: val,
        }
      }
      if (this.selectStatus.key && this.selectStatus.key != 'all') {
        params.state = this.selectStatus.key
      } else {
        if (this.active == 1) {
          params.state == 'end'
        } else {
          params.state == 'appointment'
        }
      }
      if (this.active == 1) {
        this.appointmentInvitationList = []
        this.invitePage = 1
        this.fetchInviteAppointmentList(params)
      } else {
        this.myPage = 1
        this.fetchAppointmentList(params)
      }
    },
    choseTime(data) {
      this.date = ''
      this.originDate = ''
      this.allTime.map((item) => {
        if (item.key == data.key) {
          item.color = '#ffffff'
          item.backgroundColor = '#009BFF'
          this.selectTime = { key: item.key, value: item.value }
        } else {
          item.color = '#666666'
          item.backgroundColor = '#F4F4F4'
        }
      })
    },
    choseStatus(data) {
      this.allStates.map((item) => {
        if (item.key == data.key) {
          item.color = '#ffffff'
          item.backgroundColor = '#009BFF'
          this.selectStatus = { key: item.key, value: item.value }
        } else {
          item.color = '#666666'
          item.backgroundColor = '#F4F4F4'
        }
      })
    },
    choseAction(data) {
      this.allAction.map((item) => {
        if (item.key == data.key) {
          item.color = '#ffffff'
          item.backgroundColor = '#009BFF'
          this.selectStatus = { key: item.key, value: item.value }
        } else {
          item.color = '#666666'
          item.backgroundColor = '#F4F4F4'
        }
      })
    },
    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },
    formatDate(date) {
      let weekday = new Array(7)
      weekday[0] = this.$t('周日')
      weekday[1] = this.$t('周一')
      weekday[2] = this.$t('周二')
      weekday[3] = this.$t('周三')
      weekday[4] = this.$t('周四')
      weekday[5] = this.$t('周五')
      weekday[6] = this.$t('周六')

      return this.$t('{slot1}月{slot2}日 {slot3}', {
        slot1: date.getMonth() + 1,
        slot2: date.getDate(),
        slot3: weekday[date.getDay()],
      })
    },
    onConfirm(date) {
      this.dateShow = false
      if (this.selectTime.key) {
        this.date = ''
        this.originDate = ''
        if (this.selectTime.key == 1) {
          let day = new Date()
          this.originDate = day
          this.startTime = ''
          this.endTime = ''
        } else if (this.selectTime.key == 2) {
          let day = new Date()
          this.originDate = day
          if (this.active != 1) {
            this.startTime = dayjs(day).format('YYYY-MM-DD 00:00:00')
            this.endTime = dayjs(day)
              .add(6, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(day).format('YYYY-MM-DD 00:00:00')
            this.newEndTime = dayjs(day)
              .add(6, 'day')
              .format('YYYY-MM-DD 23:59:59')
          } else {
            this.startTime = dayjs(day)
              .subtract(6, 'day')
              .format('YYYY-MM-DD 00:00:00')
            this.endTime = dayjs(day).format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(day)
              .subtract(6, 'day')
              .format('YYYY-MM-DD 00:00:00')
            this.newEndTime = dayjs(day).format('YYYY-MM-DD 23:59:59')
          }
        } else {
          let day = new Date()
          this.originDate = date
          if (this.active != 1) {
            this.startTime = dayjs(day).format('YYYY-MM-DD 00:00:00')
            this.endTime = dayjs(day)
              .add(30, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(day).format('YYYY-MM-DD 00:00:00')
            this.newEndTime = dayjs(day)
              .add(30, 'day')
              .format('YYYY-MM-DD 23:59:59')
          } else {
            this.startTime = dayjs(day)
              .subtract(30, 'day')
              .format('YYYY-MM-DD 00:00:00')
            this.endTime = dayjs(day).format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(day)
              .subtract(30, 'day')
              .format('YYYY-MM-DD 00:00:00')
            this.newEndTime = dayjs(day).format('YYYY-MM-DD 23:59:59')
          }
        }
      } else {
        this.date = this.formatDate(date)
        this.originDate = date
        this.startTime = dayjs(date).format('YYYY-MM-DD 00:00:00')
        this.endTime = dayjs(date).format('YYYY-MM-DD 23:59:59')
        this.newStartTime = dayjs(date).format('YYYY-MM-DD 00:00:00')
        this.newEndTime = dayjs(date).format('YYYY-MM-DD 23:59:59')
      }
      let params = {}
      if (this.selectTime.key != 1) {
        params = {
          endTime: this.endTime,
          startTime: this.startTime,
          weekly: 1,
        }
      }
      if (this.searchValue) {
        params.fuzzyValue = this.searchValue
      }
      if (this.active == 1) {
        if (this.selectStatus.key && this.selectStatus.key != 'all') {
          params.state = this.selectStatus.key
        } else {
          params.state = 'end'
        }
        this.inviteFinished = false
        this.invitePage = 1
        this.appointmentInvitationList = []
        this.fetchInviteAppointmentList(params)
        let newSearch = []
        if (this.selectTime.value) {
          newSearch.push(this.selectTime.value)
        }
        if (this.selectStatus.value) {
          newSearch.push(this.selectStatus.value)
        }
        this.inSearch = newSearch
      } else {
        if (this.selectStatus.key && this.selectStatus.key != 'all') {
          params.state = this.selectStatus.key
        } else {
          params.state = 'appointment'
        }
        this.myFinished = false
        this.myPage = 1
        this.reserveList = []
        this.fetchAppointmentList(params)
        let newSearch = []
        if (this.selectTime.value) {
          newSearch.push(this.selectTime.value)
        }
        if (this.selectStatus.value) {
          newSearch.push(this.selectStatus.value)
        }
        this.mySearch = newSearch
      }
    },
    onSelect(date) {
      this.selectTime = { key: '', value: '' }
      this.allTime.map((item) => {
        item.color = '#666666'
        item.backgroundColor = '#F4F4F4'
      })
    },
    // onAreaConfirm(v) {
    //   const { name = '全部', areaId = '' } = v
    //   this.currentArea = name
    //   this.areaShow = false
    //   let params = {}
    //   if (areaId) {
    //     this.currentAreaId = areaId
    //     params = {
    //       endTime: this.endTime,
    //       startTime: this.startTime,
    //       areaId,
    //       weekly: 1,
    //     }
    //   } else {
    //     this.currentAreaId = ''
    //     params = {
    //       endTime: this.endTime,
    //       startTime: this.startTime,
    //       weekly: 1,
    //     }
    //   }
    //   this.fetchAppointmentList(params)
    // },
    onAreaCancel() {
      this.areaShow = false
    },
    async getAreaId(developerId) {
      try {
        const res = await getWorkspace({
          developerId,
        })
        this.meetingRoom = [...res]
        res.forEach((v) => {
          let data = {
            name: v.name,
            areaId: v.id,
          }
          this.areaNameList.push(data)
        })
      } catch (error) {
        console.log(error.response.data.message)
      }
    },
    async fetchAppointmentList(data) {
      let newData = {}
      if (this.user.companyId) {
        data && (newData = { ...data })
        newData['companyId'] = this.user.companyId
        // newData['userId'] = this.user.id
        newData.page = this.myPage
        newData.weekly = 1
      }
      try {
        const res = await queryMyAppointmentList(newData)
        if (res.results) {
          let arr = res.results.filter(
            (item) =>
              item.weeklyMeetingId == undefined || item.weeklyMeetingId != 0
          )
          let tmpArr = arr.map((item) => {
            item.appointmentStaff == this.user.id
              ? (item.stateName = this.$t('已确认'))
              : item.agree || item.agree == false
                ? item.agree
                  ? (item.stateName = this.$t('已确认'))
                  : (item.stateName = this.$t('已拒绝'))
                : (item.stateName = this.$t('待确认'))
            item.actualStartTime
              ? (item.earlyEnd = true)
              : dayjs().isBefore(dayjs(item.appointmentStartTime))
                ? (item.earlyEnd = false)
                : (item.earlyEnd = true)
            // item.state && item.state == 'cancel'
            //   ? (item.stateName = '已取消')
            //   : dayjs().isAfter(dayjs(item.appointmentEndTime)) || item.state == 'complete'
            //   ? (item.stateName = '已结束')
            //   : dayjs().isBefore(dayjs(item.appointmentStartTime))
            //   ? (item.stateName = '未开始')
            //   : (item.stateName = '进行中')
            return item
          })
          this.reserveList = [...this.reserveList, ...tmpArr]
          // tmpArr.map(item => {
          //   if (
          //     dayjs().isAfter(dayjs(item.appointmentEndTime)) ||
          //     item.state == 'complete' ||
          //     item.state == 'cancel'
          //   ) {
          //     overList.push(item)
          //   } else {
          //     reserveList.push(item)
          //   }
          // })
          // if (!this.isSearch) {
          //   this.overList = [...this.overList, ...overList]
          //   this.reserveList = [...this.reserveList, ...reserveList]
          // }
          if (res?.results.length < 20) {
            this.showMyBottom = true
            this.myFinished = true
          } else {
            this.showMyBottom = false
          }
          this.myLoading = false
          this.isCancel = false
          if (data && data.loading) {
            setTimeout(() => {
              this.isLoading = false
              this.isCancel = false
            }, 500)
          }
        }
      } catch (error) {
        this.isLoading = false
        this.isCancel = false
      }
    },
    async fetchInviteAppointmentList(data) {
      let newData = {}
      if (this.user.companyId) {
        data && (newData = { ...data })
        newData['companyId'] = this.user.companyId
        // newData['userId'] = this.user.id
        newData.page = this.invitePage
        newData.weekly = 1
      }
      try {
        const newRes = await queryMyAppointmentList(newData)
        if (newRes.results) {
          let newArr = newRes.results.filter(
            (item) =>
              item.weeklyMeetingId == undefined || item.weeklyMeetingId != 0
          )
          let newTmpArr = newArr.map((item) => {
            item.state && item.state == 'cancel' && item.autoRelease != 1
              ? (item.stateName = this.$t('已取消'))
              : dayjs().isAfter(
                dayjs(
                  item.actualEndTime
                    ? item.actualEndTime
                    : item.appointmentEndTime
                )
              ) || item.state == 'complete'
                ? (item.stateName = this.$t('已结束'))
                : (item.stateName = '')
            return item
          })
          this.appointmentInvitationList = [
            ...this.appointmentInvitationList,
            ...newTmpArr,
          ]
          if (newRes?.results.length < 20) {
            this.showInviteBottom = true
            this.inviteFinished = true
          } else {
            this.showInviteBottom = false
          }
          this.inviteLoading = false
          this.isCancel = false
          if (data && data.loading) {
            setTimeout(() => {
              this.isLoading = false
              this.isCancel = false
            }, 500)
          }
        }
      } catch (error) {
        this.isLoading = false
        this.isCancel = false
      }
    },
    async getMettingConfig() {
      const data = {}
      if (this.user.companyId) {
        data['developerId'] = this.user.companyId
        const res = await getMeetingRoomConfig(data)
        this.meetingConfig = { ...res }
      }
    },
    // getColor(data) {
    //   let style = {}
    //   if (!data) {
    //     return
    //   }
    //   if (data.state == 'cancel') {
    //     style.color = '#000'
    //     style.borderColor = '#B7EB8F'
    //     style.backgroundColor = '#F6FFED'
    //   } else if (dayjs().isAfter(dayjs(data.appointmentEndTime)) || data.state == 'complete') {
    //     style.color = '#000'
    //     style.borderColor = '#B7EB8F'
    //     style.backgroundColor = '#F6FFED'
    //   } else if (dayjs().isBefore(dayjs(data.appointmentStartTime))) {
    //     style.color = '#FFAD00'
    //     style.borderColor = '#B7EB8F'
    //     style.backgroundColor = '#F6FFED'
    //   } else {
    //     style.color = '#52C41A'
    //     style.borderColor = '#B7EB8F'
    //     style.backgroundColor = '#F6FFED'
    //   }
    //   return style
    // },
    getStatusColor(data) {
      let style = {}
      if (!data) {
        return
      }
      if (data.agree) {
        style.color = '#1890FF'
        style.borderColor = '#91D5FF'
        style.backgroundColor = '#E6F7FF'
      } else if (data.agree == false) {
        style.color = '#FF4D4F'
        style.borderColor = '#FFA39E'
        style.backgroundColor = '#FFF1F0 '
      } else {
        style.borderWidth = '0px'
      }
      return style
    },
    onSignIn(data) {
      if (
        dayjs().isBefore(dayjs(data.appointmentStartTime)) &&
        data.state != 'cancel'
      ) {
        this.$router.push({
          path: 'mettingAttendance',
          query: { signTemplateId: data.signTemplateId || '', id: data.id },
        })
      } else {
        Toast({
          message: this.$t('签到已结束，请前往web端下载签到名单!'),
          position: 'top',
        })
      }
    },
    clickeCancel() {
      this.showCancel = false
      this.isCancel = true
      if (!dayjs().isBefore(dayjs(this.cancelData.appointmentStartTime))) {
        Toast(this.$t('本会议已开始，不可取消，请刷新获取最新状态！'))
        return
      }
      if (this.cancelData?.meetingRoomId) {
        cancelMeeting(this.cancelData.id).then(() => {
          //取消成功
          Toast(this.$t('会议已取消！'))
          this.onConfirm(this.originDate)
        })
      } else {
        cancelOnlineMeeting(this.cancelData.id).then(() => {
          Toast(this.$t('会议已取消！'))
          this.onConfirm(this.originDate)
        })
      }
    },
    onCancel(data) {
      this.cancelData = data
      this.showCancel = true
    },
    clickeEarlyEnd() {
      this.showEarlyEnd = false
      this.isCancel = true
      if (this.earlyEndData) {
        deleteAppointment(this.earlyEndData.id).then(() => {
          //取消成功
          Toast(this.$t('会议已提前结束！'))
          this.onConfirm(this.originDate)
        })
      }
    },
    onEarlyEnd(data) {
      this.earlyEndData = data
      this.showEarlyEnd = true
    },
    onNotice(item) {
      this.$router.push({
        name: 'Notice',
        query: {
          appointmentId: item.id,
          meetingRoomId: item.meetingRoomId,
        },
      })
    },
    async clickeRefuse() {
      if (!this.message && !this.ifAgree) {
        return
      }
      let staffId = this.user.id
      let value = {
        appointmentRecordId: this.refuseData.id,
        staffId,
        opinion: false,
      }
      await saveMeetingMessage({
        staffId,
        remark: this.message,
        meetingId: this.refuseData.id,
        agree: 0,
      })
      const res = await refuseMeeting(value)
      Toast(this.$t('会议已拒绝！'))
      let params = {}

      if (this.selectTime.key && this.originDate) {
        if (this.selectTime.key == 1) {
          params.startTime = ''
          params.endTime = ''
        } else if (this.selectTime.key == 2) {
          if (this.active != 1) {
            params.startTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
            params.endTime = dayjs(this.originDate)
              .add(6, 'day')
              .format('YYYY-MM-DD 23:59:59')
          } else {
            params.startTime = dayjs(this.originDate)
              .subtract(6, 'day')
              .format('YYYY-MM-DD 00:00:00')
            params.endTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 23:59:59'
            )
          }
        } else {
          if (this.active != 1) {
            params.startTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
            params.endTime = dayjs(this.originDate)
              .add(30, 'day')
              .format('YYYY-MM-DD 23:59:59')
          } else {
            params.startTime = dayjs(this.originDate)
              .subtract(30, 'day')
              .format('YYYY-MM-DD 00:00:00')
            params.endTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 23:59:59'
            )
          }
        }
      } else {
        if (this.originDate) {
          params.startTime = dayjs(this.originDate).format(
            'YYYY-MM-DD 00:00:00'
          )
          params.endTime = dayjs(this.originDate).format('YYYY-MM-DD 23:59:59')
        }
      }
      if (this.user.companyId) {
        params['companyId'] = this.user.companyId
        params['userId'] = this.user.id
      }
      if (this.selectStatus.key && this.selectStatus.key != 'all') {
        params.state = this.selectStatus.key
      }
      if (this.searchValue) {
        params.fuzzyValue = this.searchValue
      }
      params.state = 'appointment'
      this.invitePage = 1
      this.myPage = 1
      this.reserveList = []
      this.fetchAppointmentList(params)
      // const newRes = await queryMyAppointmentList(params)
      // if (newRes.results) {
      //   let newArr = newRes.results.filter(
      //     item => item.weeklyMeetingId == undefined || item.weeklyMeetingId != 0
      //   )
      //   let newTmpArr = newArr.map(item => {
      //     item.state && item.state == 'cancel'
      //       ? (item.stateName = '已取消')
      //       : dayjs().isAfter(dayjs(item.appointmentEndTime)) || item.state == 'complete'
      //       ? (item.stateName = '已结束')
      //       : ''
      //     return item
      //   })
      //   this.reserveList = newTmpArr
      // }
    },
    async checkRepeat(data) {
      const res = await dateOverlap({
        staffIds: this.user.id,
        beginTime: data.appointmentStartTime,
        endTime: data.appointmentEndTime,
      })
      if (res.length) {
        let arr = res[0]?.dateOverlaps.filter(
          (item) => item.appointmentId != data.id
        )
        if (arr.length) {
          this.repeatList = arr
          this.refuseData = data
          this.showRepeat = true
        } else {
          this.ifAgree = true
          this.refuseData = data
          this.showRefuse = true
        }
      } else {
        this.ifAgree = true
        this.refuseData = data
        this.showRefuse = true
      }
    },
    async onRefuse(data, flag) {
      let staffId = this.user.id
      let value = {
        appointmentRecordId: data.id,
        staffId,
        opinion: flag ? true : false,
      }
      if (!flag) {
        this.ifAgree = false
        this.refuseData = data
        this.showRefuse = true
      } else {
        refuseMeeting(value).then(async (res) => {
          if (this.message) {
            await saveMeetingMessage({
              staffId,
              remark: this.message,
              meetingId: this.refuseData.id,
            })
          }
          Toast(this.$t('会议已确认！'))
          let params = {}
          if (this.selectTime.key && this.originDate) {
            if (this.selectTime.key == 1) {
              params.startTime = ''
              params.endTime = ''
            } else if (this.selectTime.key == 2) {
              if (this.active != 1) {
                params.startTime = dayjs(this.originDate).format(
                  'YYYY-MM-DD 00:00:00'
                )
                params.endTime = dayjs(this.originDate)
                  .add(6, 'day')
                  .format('YYYY-MM-DD 23:59:59')
              } else {
                params.startTime = dayjs(this.originDate)
                  .subtract(6, 'day')
                  .format('YYYY-MM-DD 00:00:00')
                params.endTime = dayjs(this.originDate).format(
                  'YYYY-MM-DD 23:59:59'
                )
              }
            } else {
              if (this.active != 1) {
                params.startTime = dayjs(this.originDate).format(
                  'YYYY-MM-DD 00:00:00'
                )
                params.endTime = dayjs(this.originDate)
                  .add(30, 'day')
                  .format('YYYY-MM-DD 23:59:59')
              } else {
                params.startTime = dayjs(this.originDate)
                  .subtract(30, 'day')
                  .format('YYYY-MM-DD 00:00:00')
                params.endTime = dayjs(this.originDate).format(
                  'YYYY-MM-DD 23:59:59'
                )
              }
            }
          } else {
            if (this.originDate) {
              params.startTime = dayjs(this.originDate).format(
                'YYYY-MM-DD 00:00:00'
              )
              params.endTime = dayjs(this.originDate).format(
                'YYYY-MM-DD 23:59:59'
              )
            }
          }
          if (this.user.companyId) {
            params['companyId'] = this.user.companyId
            params['userId'] = this.user.id
          }
          if (this.selectStatus.key && this.selectStatus.key != 'all') {
            params.state = this.selectStatus.key
          }
          if (this.searchValue) {
            params.fuzzyValue = this.searchValue
          }
          params.state = 'appointment'
          this.invitePage = 1
          this.myPage = 1
          this.reserveList = []
          this.fetchAppointmentList(params)
          // const newRes = await queryMyAppointmentList(params)
          // if (newRes.results) {
          //   let newArr = newRes.results.filter(
          //     item => item.weeklyMeetingId == undefined || item.weeklyMeetingId != 0
          //   )
          //   let newTmpArr = newArr.map(item => {
          //     item.state && item.state == 'cancel'
          //       ? (item.stateName = '已取消')
          //       : dayjs().isAfter(dayjs(item.appointmentEndTime)) || item.state == 'complete'
          //       ? (item.stateName = '已结束')
          //       : ''
          //     return item
          //   })
          //   this.reserveList = newTmpArr
          // }
          this.showRepeat = false
          this.message = ''
        })
      }
    },
    mettingInfo(data, flag) {
      if (flag == 2) {
        data.appointmentStartTime = dayjs()
          .add(1, 'hour')
          .format('YYYY-MM-DD HH:00:00')
        data.appointmentEndTime = dayjs(data.appointmentStartTime)
          .add(15, 'minute')
          .format('YYYY-MM-DD HH:mm:ss')
      }
      let ifOnline = !data.meetingRoomDto
      if (!flag) {
        let active = this.active
        this.$router.push({
          name: 'MettingInforRead',
          query: {
            appointmentId: data.id,
          },
        })
      } else {
        this.$router.push({
          name: 'MettingInfor',
          params: {
            mettingData: data,
            mettingRoomList: this.meetingRoom,
            originDate: new Date(data.appointmentStartTime),
            ifOnline,
            ifAgain: flag,
          },
        })
      }
    },
    async onRefresh() {
      let data = { loading: true }
      if (this.selectTime.key && this.originDate) {
        this.date = ''
        if (this.selectTime.key == 1) {
          data.startTime = ''
          data.endTime = ''
          this.newEndTime = ''
          this.newStartTime = ''
        } else if (this.selectTime.key == 2) {
          if (this.active != 1) {
            data.startTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
            data.endTime = dayjs(this.originDate)
              .add(6, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newEndTime = dayjs(this.originDate)
              .add(6, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
          } else {
            data.startTime = dayjs(this.originDate)
              .subtract(6, 'day')
              .format('YYYY-MM-DD 00:00:00')
            data.endTime = dayjs(this.originDate).format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(this.originDate)
              .subtract(6, 'day')
              .format('YYYY-MM-DD 00:00:00')
            this.newEndTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 23:59:59'
            )
          }
        } else {
          if (this.active != 1) {
            data.startTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
            data.endTime = dayjs(this.originDate)
              .add(30, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newEndTime = dayjs(this.originDate)
              .add(30, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
          } else {
            data.startTime = dayjs(this.originDate)
              .subtract(30, 'day')
              .format('YYYY-MM-DD 00:00:00')
            data.endTime = dayjs(this.originDate).format('YYYY-MM-DD 23:59:59')
            this.newEndTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 23:59:59'
            )
            this.newStartTime = dayjs(this.originDate)
              .subtract(30, 'day')
              .format('YYYY-MM-DD 00:00:00')
          }
        }
      } else {
        if (this.originDate) {
          data.startTime = dayjs(this.originDate).format('YYYY-MM-DD 00:00:00')
          data.endTime = dayjs(this.originDate).format('YYYY-MM-DD 23:59:59')
          this.newEndTime = dayjs(this.originDate)
            .add(30, 'day')
            .format('YYYY-MM-DD 23:59:59')
          this.newStartTime = dayjs(this.originDate).format(
            'YYYY-MM-DD 00:00:00'
          )
        }
      }
      if (this.searchValue) {
        data.fuzzyValue = this.searchValue
      }
        switch (this.active) {
        case 0:
          data.state = 'appointment'
          this.showMyBottom = false
          this.overList = []
          this.reserveList = []
          this.myPage = 1
          this.fetchAppointmentList(data)
          break
        case 1:
          data.state = 'end'
          this.showInviteBottom = false
          this.appointmentInvitationList = []
          this.invitePage = 1
          this.fetchInviteAppointmentList(data)
          break
      }
    },
    onLoad() {
      let data = {}
      if (this.selectTime.key && this.originDate) {
        this.date = ''
        if (this.selectTime.key == 1) {
          data.startTime = ''
          data.endTime = ''
          this.newEndTime = ''
          this.newStartTime = ''
        } else if (this.selectTime.key == 2) {
          if (this.active != 1) {
            data.startTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
            data.endTime = dayjs(this.originDate)
              .add(6, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newEndTime = dayjs(this.originDate)
              .add(6, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
          } else {
            data.startTime = dayjs(this.originDate)
              .subtract(6, 'day')
              .format('YYYY-MM-DD 00:00:00')
            data.endTime = dayjs(this.originDate).format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(this.originDate)
              .subtract(6, 'day')
              .format('YYYY-MM-DD 00:00:00')
            this.newEndTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 23:59:59'
            )
          }
        } else {
          if (this.active != 1) {
            data.startTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
            data.endTime = dayjs(this.originDate)
              .add(30, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newEndTime = dayjs(this.originDate)
              .add(30, 'day')
              .format('YYYY-MM-DD 23:59:59')
            this.newStartTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 00:00:00'
            )
          } else {
            data.startTime = dayjs(this.originDate)
              .subtract(30, 'day')
              .format('YYYY-MM-DD 00:00:00')
            data.endTime = dayjs(this.originDate).format('YYYY-MM-DD 23:59:59')
            this.newEndTime = dayjs(this.originDate).format(
              'YYYY-MM-DD 23:59:59'
            )
            this.newStartTime = dayjs(this.originDate)
              .subtract(30, 'day')
              .format('YYYY-MM-DD 00:00:00')
          }
        }
      } else {
        if (this.originDate) {
          data.startTime = dayjs(this.originDate).format('YYYY-MM-DD 00:00:00')
          data.endTime = dayjs(this.originDate).format('YYYY-MM-DD 23:59:59')
        }
      }
      switch (this.active) {
        case 0:
          data.state = 'appointment'
          this.myPage += 1
          this.fetchAppointmentList(data)
          break
        case 1:
          data.state = 'end'
          this.invitePage += 1
          this.fetchInviteAppointmentList(data)
          break
      }
    },
    goBack() {
      this.$router.push('meeting')
    },
    checkRemark(action, done) {
      if (action === 'confirm') {
        if (!this.message && !this.ifAgree) {
          done(false)
        } else {
          done()
        }
      } else {
        done()
        this.message = ''
      }
    },
  },
  mounted() {
    if (this.$route.params.active) {
      this.active = this.$route.params.active
      this.newActive = this.$route.params.active
    }
    this.height = document.body.scrollHeight - 135
    this.selectTime = { key: '2', value: this.$t('一周内') }
    this.selectStatus = { key: 'all', value: this.$t('全部状态') }
    this.originDate = new Date()
    this.user = JSON.parse(localStorage.getItem('user'))
    // this.onConfirm(new Date())
    this.onLoad()
    this.getAreaId(this.user.companyId)
    this.getMettingConfig()
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.van-tab--active {
  color: #009bff !important;
  font-size: 14px;
}

.van-tabs {
  background: #ffffff !important;
  font-size: 14px;
}

.bookMeetings {
  position: relative;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex:1 // .content {
  //   flex: 1;
  //   overflow: auto;
  // }
}

.content {
  padding: 0 10px;
}

.selectionBar {
  height: 40px;
  background: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  width: 100%;

  .calendar {
    // width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }
  }
}

.card {
  margin-top: 8px;
  min-height: 136px;
  widows: '100%';
  background: #fefffe;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px;

  .card-header {
    display: flex;
    padding: 12px 16px 0 16px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    line-height: 24px;

    .area {
      font-size: 16px;
      max-width: 80%;
      font-weight: 600;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -o-text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 2;
      // word-wrap: break-word;
    }

    .areaMore {
      font-size: 16px;
      max-width: 80%;
      font-weight: 600;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -o-text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 2;
      // word-wrap: break-word;
    }

    img {
      width: 24px;
      height: 24px;
    }
  }

  .meetingStatus {
    padding: 2px 4px;
    height: 22px;
    background: #e6f7ff;
    border-radius: 2px;
    border: 1px solid #91d5ff;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .meetingStatusColor {
    font-size: 12px;
    font-weight: 400;
    color: #1890ff;
  }

  .time-header {
    display: flex;
    padding: 0 16px;
    align-items: center;
    margin-bottom: 4px;
  }

  .meetingtime {
    height: 24px;
    font-size: 13px;
    color: #999999;
    line-height: 24px;
    margin-right: 16px;
    max-width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .operation {
    padding: 0 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .cancelDestine {
      width: 64px;
      height: 28px;
      border-radius: 24px;
      border: 1px solid #009bff;
      color: #009bff;
      font-size: 13px;
      margin-right: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .editDestine {
      width: 64px;
      height: 28px;
      background: #009bff;
      border-radius: 24px;
      color: #ffffff;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .rejectDestine {
      width: 64px;
      height: 28px;
      background: #ff4d4f;
      border-radius: 15px;
      border: 1px solid #ff4d4f;
      color: #ffffff;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 6px;
    }

    .orderDestine {
      width: 80px;
      height: 28px;
      background: #009bff;
      border-radius: 24px;
      color: #ffffff;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .notify {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 28px;
      border-radius: 24px;
      background: #009bff;
      color: #ffffff;
      font-size: 13px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }

    .meeting {
      color: #009bff;
      font-size: 14px;
      line-height: 28px;
    }
  }

  .operationStatus {
    height: 28px;
    margin-top: 10px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 28px;

    .action {
      display: flex;
      align-items: center;
      font-size: 13px;
    }

    .refuse {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 64px;
      height: 28px;
      border-radius: 15px;
      color: #ff4d4f;
      border: 1px #ffa39e solid;
      margin-right: 6px;
    }

    .notRefuse {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 64px;
      height: 28px;
      border-radius: 24px;
      color: #ffffff;
      background: #009bff;
    }
  }
}

.meeting {
  color: #009bff;
}

/deep/.date-border {
  color: #009bff;
}

.dateModalTab {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 120px;
  padding: 17px 0 13px;
  overflow: hidden;

  .dateModalList {
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
    padding: 0 5px;
    padding-left: 16px;
    margin-bottom: 13px;

    .dateModalListOne {
      margin-right: 8px;
      border-radius: 4px;
    }
  }
}

.dateModalListText {
  width: 80px;
  height: 32px;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
}

.sort {
  margin-top: 6px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 6px;
}

.sort-card {
  min-width: 52px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-right: 8px;
  font-size: 12px;
  padding: 0 8px;
  color: rgba(0, 0, 0, 0.65);
  background: rgba(0, 0, 0, 0.04);
}

.van-search {
  width: 320px !important;
  height: 30px !important;
  padding-left: 16px !important;
  padding-right: 0 !important;
  margin-right: 15px !important;
}

.van-dialog {
  border-radius: 4px !important;
}

.bottom {
  display: flex;
  align-items: center;
  padding: 30px 0;
  justify-content: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;

  >div {
    width: 96px;
    height: 1px;
    background: rgba(0, 0, 0, 0.15);
  }

  span {
    flex-shrink: 0;
    padding: 0 17px;
  }
}

.no-uesdMeetingRoom {
  margin-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  color: #666666;
  font-size: 14px;

  img {
    width: 96px;
    height: 61px;
    margin-bottom: 8px;
  }
}

.just-marginTop {
  margin-top: 8px;
}

/deep/.van-cell::after {
  border: none;
}

/deep/.outsiderStyle {
  width: 296px;

  .outsider-title {
    font-size: 18px;
    line-height: 24px;
  }

  .van-cell::after {
    border: none;
  }

  .van-dialog__header {
    padding: 32px 0px 13px;
  }

  .cancel-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 0 0 20px 49px;

    .first-cancel {
      margin-bottom: 7px;
    }
  }

  .refuse-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 10px 0 41px;
    display: flex;
    justify-content: center;
  }

  .van-field__label {
    margin-left: 19px;
    width: 29px;
    line-height: 36px;
    font-size: 14px;
    margin-right: 8px;
  }

  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }

  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }

  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }

  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}

.hasBorder {
  .van-field__label {
    width: 25%;
    text-align: center;
  }

  .van-cell__value {
    border: 1px #dcdcdc solid !important;
    padding: 0 8px;
    width: 60%;
  }
}

.loading-style {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}

.repeat-title {
  margin-top: -8px;
}

.repeat-box {
  margin-top: -5px;

  .repeat-tip {
    padding: 0 26px;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    margin-bottom: 16px;
  }
}

.repeat-info {
  padding-left: 21px;
  padding-right: 21px;
  font-size: 12px;
  color: #999999;
  line-height: 24px;

  .repeat-info-box {
    display: flex;
    justify-content: space-between;
  }
}

.today-icon {
  width: 28px;
  height: 20px;
  margin-right: 8px;
}

.remark-box {
  width: 224px;
  min-height: 80px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.margin8 {
  margin: 0 auto 8px;
}

.margin-repaet {
  margin: 8px auto 16px;
}

.isCancelMask {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
